/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface BodyProps {
  idLead: string | null;
  identificaCliente: boolean;
}

interface Params {
  idLeadCorretor: string;
  body: BodyProps;
}

export function useIdentificaCliente(props: Params) {
  const registerData = async () => {
    const ALTERAR_IDENTIFICA_CLIENTE = `/${leadsWebEnviroment}/commom/leads/alterar-identifica-cliente/v1/${props?.idLeadCorretor}`;
    return await instance.put(ALTERAR_IDENTIFICA_CLIENTE, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_identifica_lead"],
    onSuccess: () => {
      toast.success(
        props?.body?.identificaCliente === true
          ? "Agora o Lead é um cliente"
          : "Agora o Lead não é mais um cliente",
        {
          autoClose: 10000,
        }
      );
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
